<template>
  <b-card
    class="card-transaction"
    no-body
  >
    <b-card-header>
      <b-card-title>{{ $t('Advisors Stat') }}</b-card-title>
    </b-card-header>

    <b-card-body>
      <ChartjsComponentBarChart
        v-if="!loading"
        id="doctorate-statistics-chart"
        :options="chartOptions"
        :data="chartData"
      />
    </b-card-body>
  </b-card>
</template>
<script>
import {
  BCard, BCardHeader, BCardTitle,
  BCardBody,
} from 'bootstrap-vue'
import ChartjsComponentBarChart from '@/views/pages/chart/charts-components/ChartjsComponentBarChart.vue'

export default {
  name: 'AdvisorsStat',
  components: {
    ChartjsComponentBarChart,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
  },
  props: {
    isOtm: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      chartData: {
        labels: [],
        datasets: [
          {
            label: this.$t('Soni'),
            backgroundColor: ['#3e95cd', '#e8c3b9', '#8e5ea2', '#3cba9f', '#e8c3b9', '#c45850'],
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
            },
          }],
        },
      },
    }
  },
  created() {
    this.loading = true
    console.log(this.isOtm)
    this.$store.dispatch(`statistic/get${this.isOtm ? 'Org' : 'Min'}AdvisorsStat`).then(({ data }) => {
      Object.keys(data).forEach(key => {
        this.chartData.labels.push(this.$t(`AdvisorStat.${key}`))
        this.chartData.datasets[0].data.push(data[key] ?? 0)
      })
      this.loading = false
    })
  },
}
</script>
